'use client';
import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster
      position="bottom-right"
      theme="dark"
      toastOptions={{
        style: {
          background: '#18181b',
          border: '1px solid #27272a',
          color: '#f4f4f5',
          fontFamily: 'DM Sans, sans-serif',
          fontSize: '13px',
        },
      }}
    />
  );
}